/* ============================================================
   MesJours — logique de la page (version Shopify)

   Différence essentielle avec l'ancienne version Netlify :
   le panier n'est plus une liste gardée dans le navigateur.
   C'est le VRAI panier Shopify. On l'ajoute, on le modifie et
   on le relit par l'API /cart.js — donc les prix affichés dans
   le panneau sont exactement ceux que la cliente paiera au
   moment de valider. Aucun calcul maison ne peut mentir.

   ⚙️ Ce qui se règle facilement est dans CONFIG ci-dessous.
   ============================================================ */

const CONFIG = {
  whatsapp: '224620700673',
  boutique: 'MesJours',
  adresse: 'Route Le Prince, Wanindara',

  // Prix unitaire de référence : sert à calculer l'économie affichée
  // sur les packs. Doit rester égal au prix du produit dans Shopify.
  prixReference: 170000,

  // Les packs affichés à la cliente. Cliquer un pack règle la quantité.
  // ⚠️ Ces prix doivent correspondre aux RÉDUCTIONS AUTOMATIQUES
  // configurées dans Shopify, sinon l'affichage et la caisse divergent.
  packs: [
    { qte: 1,  unit: 170000, nom: '1 culotte',   desc: 'Pour essayer', defaut: true },
    { qte: 3,  unit: 150000, nom: '3 culottes',  desc: 'Un cycle couvert', tag: 'Conseillé' },
    { qte: 6,  unit: 120000, nom: '6 culottes',  desc: 'Un cycle sans lessive', tag: 'Le plus choisi' },
    { qte: 12, unit: 100000, nom: '12 culottes', desc: 'Le prix le plus bas', tag: 'Meilleur prix' }
  ],

  paliers: [
    { desMin: 12, unit: 100000 },
    { desMin: 6,  unit: 120000 },
    { desMin: 3,  unit: 150000 },
    { desMin: 1,  unit: 170000 }
  ],

  couleurs: [
    { nom: 'Noir',       hex: '#161616' },
    { nom: 'Beige rosé', hex: '#D2B6AA' }
  ],

  tailles: ['S', 'M', 'L', 'XL', 'XXL'],

  // Nombre de pièces RÉELLEMENT en stock. 0 (ou null) masque la bannière.
  stockRestant: 0,

  /* ⚙️ PROMOTION
     reference : le prix barré, à l'unité. C'est le « prix comparé » posé
       dans Shopify — le prix normal hors promotion. Garde les deux
       cohérents : si tu changes ici, change aussi dans Shopify.
     fin : date de fin RÉELLE, au format '2026-09-07T23:59:00'.
       C'est la bonne façon de faire : le décompte descend en même temps
       pour toutes tes clientes, et celle qui revient voit qu'il reste
       vraiment moins de temps. Beaucoup plus convaincant.
     duree : utilisée seulement si « fin » est vide. Chaque visiteuse a
       alors son propre décompte, gardé sur son téléphone. */
  promo: {
    actif: true,
    // Le prix barré part du prix réel à l'unité (150 000). Pour un pack de 6,
    // on barre donc 900 000 : c'est ce que la cliente paierait vraiment en
    // achetant six culottes une par une. Le barré est exact, vérifiable, et
    // il ne met pas ton compte publicitaire en danger.
    fin: null,
    duree: 299 * 60          // 4 h 59
  }
};

/* ============================================================
   AVIS CLIENTES — retours réels transmis par la boutique.
   « enAvant: true » désigne l'avis affiché près du bouton d'ajout.
   ============================================================ */
const AVIS = [
  { quartier: 'Kipé', nom: 'Aïssatou', note: 5, texte: 'Franchement elle est super confortable, je recommande ❤️' },
  { quartier: 'Ratoma', nom: 'Mariama', note: 5, texte: 'Plus de stress pendant mes règles, j’adore 😍' },
  { quartier: 'Lambanyi', nom: 'Fatoumata', note: 5, texte: 'Très douce et agréable à porter, vraiment satisfaite.' },
  { quartier: 'Nongo', nom: 'Kadiatou', note: 5, texte: 'Je dors beaucoup plus tranquille avec elle ❤️' },
  { quartier: 'Dixinn', nom: 'Hawa', note: 5, texte: 'Elle est discrète et surtout très confortable.' },
  { quartier: 'Matam', nom: 'Aminata', note: 5, texte: 'Fini le stress des petites fuites quand je sors 😍' },
  { quartier: 'Sonfonia', nom: 'M’Mah', note: 5, texte: 'Pratique, réutilisable et ça me fait économiser.' },
  { quartier: 'Kaloum', nom: 'Binta', note: 5, texte: 'Franchement je ne regrette pas mon achat ❤️' },
  { quartier: 'Kipé', nom: 'Oumou', note: 5, texte: 'Plus aucune irritation après mes règles depuis que je la porte ❤️', enAvant: true },
  { quartier: 'Kagbelen', nom: 'Fanta', note: 5, texte: 'Très pratique pendant les règles, je recommande à 100 % 😍' }
];

/* ---------- Utilitaires ---------- */
const $  = (s, c = document) => c.querySelector(s);
const $$ = (s, c = document) => [...c.querySelectorAll(s)];

/* ---------- Où sommes-nous ? ----------
   Le script tourne sur TOUTES les pages (il est dans le pied de page).
   Mais le bloc d'achat n'existe que sur la fiche produit. Sans ce garde-fou,
   le script mourait dès la première ligne sur l'accueil — et emportait le
   panier avec lui. On ne monte le bloc d'achat que s'il est présent. */
const surFicheProduit = !!document.getElementById('paliers');

/* ---------- Les éléments flottants dépendent de l'écran, pas du pied de page ----------
   Le thème Horizon enferme le pied de page dans un conteneur qui « piège » tout
   ce qui est en position:fixed. Résultat : le panneau panier s'ouvrait À L'INTÉRIEUR
   du pied de page au lieu de recouvrir l'écran. On les rattache au <body>, qui ne
   piège rien — comme ça le panier, la fenêtre des tailles, la notification et la
   barre du bas se comportent partout de la même façon. */
['#voile', '#panier', '#toast', '#modale-tailles', '#sticky', '.fab'].forEach(sel => {
  const el = document.querySelector(sel);
  if (el && el.parentElement !== document.body) document.body.appendChild(el);
});

// Données injectées par Shopify (voir sections/mj-achat.liquid)
const D = window.MJ_DONNEES || { devise: 'GNF', variantes: [], galerie: [] };

// La devise à AFFICHER est celle que Shopify présente à la cliente (le marché
// guinéen), pas celle de la boutique : afficher « CAD » sur des montants déjà
// convertis en francs guinéens ferait fuir n'importe quelle acheteuse.
const devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
            || D.devise || 'GNF';

// Shopify renvoie toujours les montants en centimes, y compris pour
// les devises sans décimale comme le franc guinéen.
const enUnites = centimes => Math.round(centimes / 100);
const somme = n => n.toLocaleString('fr-FR').replace(/ | /g, ' ') + ' ' + devise;
const gnf = n => somme(n);                 // montant déjà en unités
const prix = centimes => somme(enUnites(centimes));  // montant venu de Shopify

const etat = {
  couleur: CONFIG.couleurs[0].nom,
  taille: '',
  qte: (CONFIG.packs.find(p => p.defaut) || CONFIG.packs[0]).qte
};

// Le panier Shopify, tel que /cart.js le renvoie
let panier = { items: [], item_count: 0, total_price: 0, original_total_price: 0, total_discount: 0 };

const totalPieces = () => panier.item_count || 0;
const palier = q => CONFIG.paliers.find(p => q >= p.desMin) || CONFIG.paliers[CONFIG.paliers.length - 1];

/* ---------- Correspondance couleur + taille → variante Shopify ---------- */
function variante(couleur, taille) {
  return D.variantes.find(v => v.couleur === couleur && v.taille === taille);
}

/* ---------- Après le pack, on emmène à l'étape suivante ----------
   Beaucoup de nos clientes commandent en ligne pour la première fois.
   Une fois le pack choisi, le choix de la couleur et de la taille est
   hors de l'écran : elles ne le cherchent pas, elles s'arrêtent là.
   On descend donc pour elles, jusqu'au bloc suivant.
   Deux garde-fous : on ne bouge pas si l'étape est déjà bien en vue —
   un défilement inutile désoriente plus qu'il n'aide — et on respecte
   le réglage « animations réduites » du téléphone. */
function versChoixTaille() {
  const cible = $('#couleurs');
  if (!cible) return;
  const etape = cible.closest('.step') || cible;
  const r = etape.getBoundingClientRect();
  const entete = $('.header') ? $('.header').offsetHeight : 0;
  if (r.top >= entete && r.bottom <= innerHeight) return;
  const doux = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  window.scrollTo({ top: r.top + scrollY - entete - 14, behavior: doux });
}

/* ---------- Ton pack : cliquer règle la quantité ---------- */
const packsEl = $('#paliers');
if (surFicheProduit) CONFIG.packs.forEach(p => {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pack';
  btn.setAttribute('role', 'radio');
  btn.setAttribute('aria-checked', String(!!p.defaut));
  btn.innerHTML = `
    <span class="pack__dot"></span>
    <span>
      <span class="pack__name">${p.nom}${p.tag ? `<span class="pack__tag">${p.tag}</span>` : ''}</span>
      <span class="pack__unit">${gnf(p.unit)} l'unité</span>
      ${p.unit < CONFIG.prixReference
        ? `<span class="pack__eco">Vous économisez ${gnf((CONFIG.prixReference - p.unit) * p.qte)}</span>`
        : ''}
    </span>
    <span class="pack__price">
      ${p.unit < CONFIG.prixReference ? `<span class="pack__avant">${gnf(p.qte * CONFIG.prixReference)}</span>` : ''}
      <span class="pack__now">${gnf(p.qte * p.unit)}</span>
    </span>`;
  btn.addEventListener('click', () => {
    etat.qte = p.qte;
    majQte();
    $$('.pack', packsEl).forEach(x => x.setAttribute('aria-checked', String(x === btn)));
    versChoixTaille();
  });
  packsEl.appendChild(btn);
});

/* ---------- Couleur ---------- */
const couleursEl = $('#couleurs');
if (surFicheProduit) CONFIG.couleurs.forEach((c, i) => {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'opt opt--color';
  b.setAttribute('role', 'radio');
  b.setAttribute('aria-checked', String(i === 0));
  b.innerHTML = `<span class="swatch" style="background:${c.hex}"></span>${c.nom}`;
  b.addEventListener('click', () => {
    etat.couleur = c.nom;
    $$('.opt--color', couleursEl).forEach(x => x.setAttribute('aria-checked', String(x === b)));
    majFormulaire();
    apercu(c.nom);
  });
  couleursEl.appendChild(b);
});

/* ---------- Taille ---------- */
const taillesEl = $('#tailles-opts');
if (surFicheProduit) CONFIG.tailles.forEach(t => {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'opt';
  b.setAttribute('role', 'radio');
  b.setAttribute('aria-checked', 'false');
  b.textContent = t;
  b.addEventListener('click', () => {
    etat.taille = t;
    $('#taille-erreur').hidden = true;
    $$('.opt', taillesEl).forEach(x => x.setAttribute('aria-checked', String(x === b)));
    majBoutonAjout();
    majFormulaire();
  });
  taillesEl.appendChild(b);
});

/* ---------- Le formulaire Shopify suit toujours la sélection ----------
   Ces deux champs cachés sont ce que Shopify lira si le script est absent.
   On les tient à jour à chaque clic pour que les deux chemins — celui du
   script et celui du formulaire — envoient toujours la même chose.      */
function majFormulaire() {
  const champV = $('#mj-variante');
  const champQ = $('#mj-quantite');
  if (!champV || !champQ) return;
  const v = variante(etat.couleur, etat.taille);
  if (v) champV.value = v.id;
  champQ.value = etat.qte;
}

/* ---------- Le bouton dit ce qui manque ----------
   Tant qu'aucune taille n'est choisie, le bouton porte lui-même
   l'instruction. Plus efficace qu'un message d'erreur après le clic :
   on ne rate pas le bouton principal de la page. */
function majBoutonAjout() {
  const b = $('#ajouter-panier');
  if (!b) return;
  if (etat.taille) {
    b.textContent = 'Ajouter au panier';
    b.classList.remove('btn--attente');
  } else {
    b.textContent = 'Choisissez votre taille';
    b.classList.add('btn--attente');
  }
  majSticky();
}

/* ---------- Quantité ---------- */
function majQte() { if (!$('#qte-val')) return; $('#qte-val').textContent = etat.qte; majFormulaire(); }
function accordePack() {
  if (!packsEl) return;
  $$('.pack', packsEl).forEach((x, i) => x.setAttribute('aria-checked', String(CONFIG.packs[i].qte === etat.qte)));
}
if (surFicheProduit) $('#qte-moins').addEventListener('click', () => { etat.qte = Math.max(1, etat.qte - 1); majQte(); accordePack(); });
if (surFicheProduit) $('#qte-plus').addEventListener('click',  () => { etat.qte = Math.min(50, etat.qte + 1); majQte(); accordePack(); });

/* ============================================================
   PANIER SHOPIFY
   ============================================================ */
async function litPanier() {
  try {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('cart.js ' + r.status);
    panier = await r.json();
  } catch (e) {
    // Panier illisible (réseau, limitation Shopify) : on n'affiche rien de faux
    // et surtout on ne casse pas le reste de la page.
    panier = { items: [], item_count: 0, total_price: 0, original_total_price: 0, total_discount: 0 };
  }
  rendre();
}

async function ajouterAuPanier(evenement) {
  const formulaire = $('#mj-form');
  if (!etat.taille) {
    $('#taille-erreur').hidden = false;
    taillesEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 400 });
    taillesEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (evenement) evenement.preventDefault();
    return;
  }
  const v = variante(etat.couleur, etat.taille);
  if (!v) {
    montreToast('Cette taille n’est pas disponible dans cette couleur.');
    if (evenement) evenement.preventDefault();
    return;
  }

  // À partir d'ici on prend la main : ajout sans rechargement, puis panneau.
  if (evenement) evenement.preventDefault();
  majFormulaire();

  const bouton = $('#ajouter-panier');
  bouton.disabled = true;

  const ajoute = etat.qte;
  const couleurAjoutee = etat.couleur;
  const tailleAjoutee = etat.taille;

  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: ajoute }] })
    });
    if (!r.ok) throw new Error(await r.text());
    await litPanier();
  } catch (e) {
    // Dernier recours : on laisse Shopify faire le travail à sa façon.
    // La cliente change de page, mais son article est bien dans le panier.
    bouton.disabled = false;
    if (formulaire) { formulaire.submit(); return; }
    montreToast('L’ajout n’a pas fonctionné. Réessayez dans un instant.');
    return;
  }
  bouton.disabled = false;

  etat.qte = (CONFIG.packs.find(p => p.defaut) || CONFIG.packs[0]).qte;
  majQte();
  accordePack();
  pastilleAnimee();

  const ok = $('#ajoute-ok');
  ok.hidden = false;
  clearTimeout(ok._t);
  ok._t = setTimeout(() => { ok.hidden = true; }, 2200);

  if (window.mjTrack) {
    window.mjTrack('AddToCart', {
      content_name: `Culotte menstruelle ${couleurAjoutee} — Taille ${tailleAjoutee}`,
      content_type: 'product',
      num_items: ajoute,
      value: enUnites(panier.total_price),
      currency: devise
    });
  }

  /* Direct à la caisse, sans passer par le panier.
     Le 8 septembre, 13 clientes sur 35 ayant rempli leur panier ne sont
     jamais arrivées à la caisse : cette étape ne servait qu'à les perdre.
     Les 250 ms laissent au pixel Meta le temps de partir — une redirection
     immédiate coupe la requête et l'événement AddToCart serait perdu. */
  bouton.disabled = true;
  bouton.textContent = 'Un instant…';
  setTimeout(versLaCaisse, 250);
}

async function changerLigne(cle, qte) {
  const r = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ id: cle, quantity: qte })
  });
  panier = await r.json();
  rendre();
}

/* ---------- Affichage du panier, à partir des vrais chiffres Shopify ---------- */
function rendre() {
  const q = totalPieces();

  const pastille = $('#panier-n');
  if (pastille) { pastille.textContent = q; pastille.hidden = !q; }

  // Encouragement au palier suivant
  const suivant = [...CONFIG.paliers].reverse().find(x => x.desMin > q);
  [$('#nudge'), $('#panier-nudge')].forEach(n => {
    if (!n) return;
    if (q && suivant) {
      n.hidden = false;
      const manque = suivant.desMin - q;
      n.innerHTML = `Ajoutez <b>${manque} pièce${manque > 1 ? 's' : ''}</b> et le prix tombe à <b>${gnf(suivant.unit)}</b> la pièce`;
    } else { n.hidden = true; }
  });

  // Les lignes du panier
  const liste = $('#panier-liste');
  liste.innerHTML = '';
  panier.items.forEach(ligne => {
    const couleur = (ligne.options_with_values || []).find(o => o.name === 'Couleur');
    const taille  = (ligne.options_with_values || []).find(o => o.name === 'Taille');
    const nomCouleur = couleur ? couleur.value : ligne.variant_title;
    const c = CONFIG.couleurs.find(x => x.nom === nomCouleur) || {};

    const li = document.createElement('li');
    li.innerHTML = `
      <span class="ligne__pastille" style="background:${c.hex || '#ccc'}"></span>
      <span class="ligne__txt"><b>${nomCouleur}</b><span>${taille ? 'Taille ' + taille.value : ''}</span></span>
      <span class="qte qte--mini">
        <button type="button" aria-label="Retirer une pièce">−</button>
        <span>${ligne.quantity}</span>
        <button type="button" aria-label="Ajouter une pièce">+</button>
      </span>
      <button type="button" class="ligne__x" aria-label="Retirer cette ligne">×</button>`;
    const [moins, plus] = li.querySelectorAll('.qte--mini button');
    moins.addEventListener('click', () => changerLigne(ligne.key, ligne.quantity - 1));
    plus.addEventListener('click',  () => changerLigne(ligne.key, ligne.quantity + 1));
    li.querySelector('.ligne__x').addEventListener('click', () => changerLigne(ligne.key, 0));
    liste.appendChild(li);
  });

  $('#panier-vide').hidden = !!q;
  $('#panier-suite').hidden = !q;
  $('#panier-bas').hidden = !q;

  $('#panier-total').textContent = prix(panier.total_price);
  const unitaire = q ? Math.round(panier.total_price / q) : 0;
  $('#panier-detail').textContent = q ? `${q} pièce${q > 1 ? 's' : ''} × ${prix(unitaire)}` : '';

  // L'économie vient de la réduction réellement appliquée par Shopify
  const be = $('#panier-eco');
  if (panier.total_discount > 0) {
    be.hidden = false;
    $('#panier-eco-txt').textContent = `Vous économisez ${prix(panier.total_discount)}`;
  } else be.hidden = true;

  majSticky();
}

function pastilleAnimee() {
  const p = $('#panier-n');
  if (!p) return;
  p.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }], { duration: 420 });
}

/* ---------- La notification qui descend du haut ---------- */
let toastT;
function montreToast(texte) {
  const t = $('#toast');
  $('#toast-txt').textContent = texte;
  t.hidden = false;
  void t.offsetWidth;
  t.classList.add('vu');
  clearTimeout(toastT);
  toastT = setTimeout(cacheToast, 3800);
}
function cacheToast() {
  const t = $('#toast');
  t.classList.remove('vu');
  setTimeout(() => { t.hidden = true; }, 280);
}
$('#toast-voir').addEventListener('click', () => { cacheToast(); versLaCaisse(); });
// On intercepte l'envoi du formulaire : ça couvre le clic, la touche Entrée
// et tout ce que Shopify pourrait déclencher.
const formAjout = $('#mj-form');
if (formAjout) formAjout.addEventListener('submit', ajouterAuPanier);
else if ($('#ajouter-panier')) $('#ajouter-panier').addEventListener('click', ajouterAuPanier);

/* ---------- Barre du bas ---------- */
let depasseAjout = false;
const zoneAjout = $('.addline');
function surveilleAjout() {
  if (!zoneAjout) return;
  const passe = zoneAjout.getBoundingClientRect().bottom < 0;
  if (passe !== depasseAjout) { depasseAjout = passe; majSticky(); }
}
let enAttente = false;
addEventListener('scroll', () => {
  if (enAttente) return;
  enAttente = true;
  requestAnimationFrame(() => { enAttente = false; surveilleAjout(); });
}, { passive: true });
addEventListener('resize', surveilleAjout, { passive: true });

function majSticky() {
  const q = totalPieces();
  $('#sticky').hidden = !(q > 0 || depasseAjout);

  const cta = $('#sticky-cta');
  if (q) {
    $('#sticky-info').hidden = false;
    $('#sticky-n').textContent = `${q} article${q > 1 ? 's' : ''}`;
    $('#sticky-total').textContent = prix(panier.total_price);
    $('#sticky-txt').textContent = 'Terminer ma commande';
    $('#sticky-pastille').hidden = false;
    $('#sticky-pastille').textContent = q;
    cta.classList.remove('btn--attente');
    cta.dataset.action = 'voir';
  } else {
    // La barre du bas dit exactement ce que dit le bouton resté plus haut :
    // la cliente descend, le bouton la suit, avec le même mot.
    $('#sticky-info').hidden = true;
    $('#sticky-txt').textContent = etat.taille ? 'Ajouter au panier' : 'Choisissez votre taille';
    cta.classList.toggle('btn--attente', !etat.taille);
    $('#sticky-pastille').hidden = true;
    cta.dataset.action = 'ajouter';
  }
}

/* La caisse, telle que Shopify l'a écrite dans le thème. */
const VERS_CAISSE = ($('#cta-commander') && $('#cta-commander').getAttribute('href')) || '/checkout';
function versLaCaisse() { window.location.href = VERS_CAISSE; }

/* ---------- Ouvrir / fermer le panier ---------- */
function ouvrirPanier() {
  const p = $('#panier');
  p.hidden = false;
  $('#voile').hidden = false;
  document.body.classList.add('fige');
  // On force le calcul de mise en page, puis on pose la classe tout de suite.
  // Avec un requestAnimationFrame, le panneau restait invisible dès que le
  // navigateur mettait la page en veille (onglet en arrière-plan, économie
  // d'énergie) : le fond se figeait mais rien ne glissait. Là, c'est certain.
  void p.offsetWidth;
  p.classList.add('ouvert');
}
function fermerPanier() {
  $('#panier').classList.remove('ouvert');
  document.body.classList.remove('fige');
  setTimeout(() => { $('#panier').hidden = true; $('#voile').hidden = true; }, 260);
}
if ($('#ouvrir-panier')) $('#ouvrir-panier').addEventListener('click', ouvrirPanier);
$('#sticky-cta').addEventListener('click', () => {
  if ($('#sticky-cta').dataset.action !== 'ajouter') { versLaCaisse(); return; }
  const f = $('#mj-form');
  if (f && typeof f.requestSubmit === 'function') f.requestSubmit();
  else ajouterAuPanier();
});
$('#fermer-panier').addEventListener('click', fermerPanier);
$('#voile').addEventListener('click', fermerPanier);

/* ---------- Vers la caisse Shopify ---------- */
$('#cta-commander').addEventListener('click', () => {
  if (window.mjTrack) {
    const donnees = {
      content_name: 'Culotte menstruelle MesJours',
      content_type: 'product',
      num_items: totalPieces(),
      value: enUnites(panier.total_price),
      currency: devise
    };
    window.mjTrack('InitiateCheckout', donnees);
    window.mjTrack('Lead', donnees);
  }
});

/* ---------- Fenêtre du guide des tailles ---------- */
if ($('#ouvrir-tailles')) $('#ouvrir-tailles').addEventListener('click', () => {
  $('#modale-tailles').hidden = false;
  document.body.classList.add('fige');
});
function fermerTailles() {
  $('#modale-tailles').hidden = true;
  if ($('#panier').hidden) document.body.classList.remove('fige');
}
$('#fermer-tailles').addEventListener('click', fermerTailles);
$('#modale-tailles').addEventListener('click', e => { if (e.target.id === 'modale-tailles') fermerTailles(); });
document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  if (!$('#modale-tailles').hidden) fermerTailles();
  else if (!$('#panier').hidden) fermerPanier();
});

/* ---------- Galerie photos ---------- */
const vignettesEl = $('#vignettes');
if (vignettesEl) D.galerie.forEach((photo, i) => {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'vignette';
  b.setAttribute('role', 'tab');
  b.setAttribute('aria-selected', String(i === 0));
  // La vignette fait 66 px : on lui envoie une image de 160 px, pas la
  // photo complète. Sur cinq vignettes, c'était l'essentiel du poids de
  // la page pour une cliente en 3G à Conakry.
  b.innerHTML = `<img src="${photo.vignette || photo.src}" alt="" width="66" height="66" decoding="async">`;
  b.addEventListener('click', () => montre(i));
  vignettesEl.appendChild(b);
});

let photoActuelle = 0;

function montre(i, defiler = true) {
  const photo = D.galerie[i];
  if (!photo || !vignettesEl || !$('#preview')) return;
  photoActuelle = i;
  const img = $('#preview');
  // Au chargement, la photo posée par Shopify est déjà la bonne. La
  // réassigner relançait un téléchargement complet et repoussait d'autant
  // l'affichage. On ne touche à l'adresse que si elle change vraiment.
  if (img.dataset.src !== photo.src) {
    if (photo.srcset) img.srcset = photo.srcset;
    img.src = photo.src;
    img.dataset.src = photo.src;
  }
  img.alt = photo.alt || '';
  $$('.vignette', vignettesEl).forEach((v, k) => v.setAttribute('aria-selected', String(k === i)));
  const active = $$('.vignette', vignettesEl)[i];
  if (active && defiler) active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
}
/* La photo posée par le serveur est déjà à l'écran : on cale simplement la
   vignette active dessus, sans rien réassigner. Si l'image mise en avant
   dans Shopify n'est pas la première de la galerie, on retombe sur
   l'ancien comportement. */
(function departGalerie() {
  const img = $('#preview');
  if (!img) return;
  const i = D.galerie.findIndex(p => p.src === img.dataset.src);
  montre(i >= 0 ? i : 0, false);
})();

/* Les autres photos sont chargées une fois la page tranquille, à la taille
   où elles seront affichées. Le clic sur une couleur ou une vignette
   n'attend plus un téléchargement : c'est ce qui pesait sur l'INP. */
(function prechargeGalerie() {
  if (D.galerie.length < 2) return;
  const plusTard = window.requestIdleCallback || (f => setTimeout(f, 1200));
  addEventListener('load', () => plusTard(() => {
    D.galerie.forEach((photo, i) => {
      if (i === photoActuelle) return;
      const im = new Image();
      im.decoding = 'async';
      if (photo.srcset) { im.sizes = '(max-width:860px) 100vw, 640px'; im.srcset = photo.srcset; }
      im.src = photo.src;
    });
  }), { once: true });
})();

/* ---------- Faire glisser les photos au doigt ----------
   Comme sur n'importe quelle boutique : on pousse la photo vers la gauche
   pour voir la suivante, vers la droite pour revenir. Les vignettes du
   dessous continuent de fonctionner, les deux cohabitent.
   On ne réagit qu'aux gestes franchement horizontaux, sinon on volerait
   le défilement vertical de la page. */
(function glisserPhotos() {
  const zone = $('.galerie');
  if (!zone || D.galerie.length < 2) return;

  let departX = 0, departY = 0, enCours = false;

  zone.addEventListener('touchstart', e => {
    if (e.touches.length !== 1) { enCours = false; return; }
    departX = e.touches[0].clientX;
    departY = e.touches[0].clientY;
    enCours = true;
  }, { passive: true });

  zone.addEventListener('touchend', e => {
    if (!enCours) return;
    enCours = false;
    const t = e.changedTouches[0];
    const dx = t.clientX - departX;
    const dy = t.clientY - departY;
    // Geste trop court, ou plutôt vertical : on laisse la page défiler.
    if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    const n = D.galerie.length;
    const suivante = dx < 0 ? (photoActuelle + 1) % n
                            : (photoActuelle - 1 + n) % n;
    montre(suivante);
  }, { passive: true });
})();

// Changer de couleur amène sur la première photo de cette couleur
function apercu(nom) {
  const i = D.galerie.findIndex(p => p.couleur === nom);
  if (i >= 0) montre(i);
}

/* ---------- Bannière de stock, uniquement si le chiffre est renseigné ---------- */
(function stock() {
  const n = CONFIG.stockRestant;
  if (!n || n < 1) return;
  const el = $('#stock');
  if (!el) return;
  el.innerHTML = n <= 20
    ? `Il ne reste que <b>${n} pièce${n > 1 ? 's' : ''}</b> en stock`
    : `<b>${n} pièces</b> disponibles en stock`;
  el.hidden = false;
})();

/* ---------- Prix de la carte, sur la page d'accueil ---------- */
$$('[data-prix]').forEach(el => { el.textContent = prix(parseInt(el.dataset.prix, 10)); });

/* ---------- Compte à rebours de la promotion ----------
   Deux modes. Si CONFIG.promo.fin contient une date, tout le monde voit
   le même décompte, qui descend vraiment — c'est le mode à privilégier.
   Sinon on donne à chaque visiteuse son propre compte à rebours, gardé
   sur son téléphone pour qu'il ne reparte pas à zéro à chaque page.   */
function promoActive() { return !!(CONFIG.promo && CONFIG.promo.actif); }

function finDePromo() {
  if (CONFIG.promo.fin) return new Date(CONFIG.promo.fin).getTime();
  const cle = 'mj-promo-fin';
  let t = 0;
  try { t = parseInt(localStorage.getItem(cle) || '0', 10); } catch (e) {}
  if (!t || t < Date.now()) {
    t = Date.now() + CONFIG.promo.duree * 1000;
    try { localStorage.setItem(cle, String(t)); } catch (e) {}
  }
  return t;
}

(function compteARebours() {
  if (!promoActive()) return;
  const barres = $$('.promo-bar');
  if (!barres.length) return;
  const fin = finDePromo();
  const deux = n => String(n).padStart(2, '0');

  function tic() {
    const reste = Math.max(0, Math.floor((fin - Date.now()) / 1000));
    const j = Math.floor(reste / 86400);
    const h = Math.floor((reste % 86400) / 3600);
    const m = Math.floor((reste % 3600) / 60);
    const s = reste % 60;
    // Au-delà d'une journée on affiche les jours : sur trois semaines,
    // « 540:12:07 » ne veut plus rien dire pour personne.
    const texte = j > 0
      ? `${j} j ${deux(h)}:${deux(m)}:${deux(s)}`
      : `${deux(h)}:${deux(m)}:${deux(s)}`;
    $$('.promo-bar__t').forEach(el => { el.textContent = texte; });
    if (reste <= 0) { barres.forEach(b => { b.hidden = true; }); return; }
    setTimeout(tic, 1000);
  }
  barres.forEach(b => { b.hidden = false; });
  tic();
})();

/* ---------- Avis clientes ---------- */
if (AVIS.length && $('#avis-grid')) {
  const court = $('#avis-court');
  if (court) [AVIS.find(a => a.enAvant) || AVIS[0]].forEach(a => {
    const c = document.createElement('figure');
    c.className = 'avis-court__c';
    c.innerHTML = `<div class="avis__stars">★★★★★</div>
      <blockquote>${a.texte}</blockquote>
      <figcaption><b>${a.quartier}</b> · ${a.nom}</figcaption>`;
    court.appendChild(c);
  });

  $('#nb-avis').textContent = 'Avis clientes';
  $('#lien-avis').hidden = false;

  const grille = $('#avis-grid');
  AVIS.forEach(a => {
    const c = document.createElement('figure');
    c.className = 'avis__card';
    c.innerHTML = `
      <div class="avis__stars">${'★'.repeat(a.note || 5)}</div>
      <blockquote>${a.texte}</blockquote>
      <figcaption>${a.quartier ? `<b>${a.quartier}</b> · ` : ''}${a.nom}</figcaption>`;
    grille.appendChild(c);
  });
  $('#avis').hidden = false;
}

/* ---------- Apparition au scroll ----------
   Trois garde-fous, parce qu'un texte qui reste invisible coûte une vente :
   1. la classe « mj-anim » n'est posée que si le script tourne (voir mj-tete) ;
   2. un filet de sécurité affiche tout au bout de 2,5 s, même si
      l'observateur n'a rien déclenché ;
   3. on refait le tour à chaque rechargement de section (éditeur de thème). */
const io = new IntersectionObserver(entries => {
  entries.forEach(en => {
    if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
  });
}, { rootMargin: '0px 0px -8% 0px' });

function animeApparition(racine = document) {
  $$('.section > .wrap > *', racine).forEach(el => {
    if (el.classList.contains('reveal')) return;
    // Ce qui est DÉJÀ à l'écran ne s'anime pas. Animer le bloc produit
    // revenait à le mettre à opacity:0 dès que le script se chargeait,
    // puis à le faire réapparaître en 0,6 s : la photo principale, que
    // Google chronomètre, n'était comptée comme affichée qu'à ce
    // moment-là. C'était la cause du LCP à 4,3 s.
    if (el.getBoundingClientRect().top < innerHeight) return;
    el.classList.add('reveal');
    io.observe(el);
  });
}
function toutAfficher() { $$('.reveal').forEach(el => el.classList.add('in')); }

animeApparition();
setTimeout(toutAfficher, 2500);
document.addEventListener('shopify:section:load', e => {
  animeApparition(e.target);
  setTimeout(toutAfficher, 2500);
});

/* ---------- Suivi Facebook ---------- */
if (window.mjTrack) {
  window.mjTrack('ViewContent', {
    content_name: 'Culotte menstruelle MesJours',
    content_type: 'product'
  });
}

/* ---------- Liens internes ----------
   On ne compte pas sur le comportement natif des ancres : selon le contexte
   de défilement, le navigateur change l'adresse sans bouger d'un pixel.   */
function vaVers(cible) {
  const avant = cible.getBoundingClientRect().top;
  cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
  setTimeout(() => {
    if (Math.abs(cible.getBoundingClientRect().top - avant) < 2) {
      cible.scrollIntoView({ block: 'start' });
    }
  }, 350);
}
$$('a[href*="#"]').forEach(a => {
  const href = a.getAttribute('href') || '';
  const id = href.split('#')[1];
  if (!id) return;
  a.addEventListener('click', e => {
    const cible = document.getElementById(id);
    if (!cible) return;
    e.preventDefault();
    vaVers(cible);
    history.replaceState(null, '', '#' + id);
  });
});

/* ---------- Démarrage ---------- */
majQte();
majBoutonAjout();
majFormulaire();
litPanier();
surveilleAjout();
